export const ERROR = 'error';
export const INFO = 'info';
export const SUCCESS = 'success';
export const WARNING = 'warning';

export const all = [
  ERROR,
  INFO,
  SUCCESS,
  WARNING
];
